import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUserProfile, IUpdatePersonalInfo } from '../../../types/user/profileInterfaces';

export const initialProfileState: IUserProfile = {
    id: 0,
    username: '',
    email: '',
    phoneNumber: '',
    profilePicture: '',
    googleAuthEnabled: false,
    firstName: '',
    middleName: '',
    lastName: '',
    secondLastName: ''
};

export interface UserProfileState {
    userProfile: IUserProfile;
}

export const initialState: UserProfileState = {
    userProfile: initialProfileState,
};

export const userProfileSlice = createSlice({
    name: 'userProfile',
    initialState,
    reducers: {
        loadUserProfile: (state, action: PayloadAction<IUserProfile>) => {
            state.userProfile = action.payload;
        },
        updateUserPersonalInfo: (state, action: PayloadAction<IUpdatePersonalInfo>) => {
            state.userProfile = { ...state.userProfile, ...action.payload };
        },
        updateUserProfilePicture: (state, action: PayloadAction<string>) => {
            state.userProfile.profilePicture = action.payload;
        },
        enableGoogleAuth: (state) => {
            state.userProfile.googleAuthEnabled = true;
        },
    },
});

export const {
    loadUserProfile,
    updateUserPersonalInfo,
    updateUserProfilePicture,
    enableGoogleAuth,
} = userProfileSlice.actions;

export default userProfileSlice.reducer;
